import { CARD_RARITIES } from "../../models/CardRarity";
import { CardVariant } from "../../models/CardVariant";
import { DeckState } from "../../models/Deck";
import { UserSettings } from "../../models/UserSettings";
import { OfficialDeckListRow } from "./types";

export function getOfficialDeckListRows(props: {
    deckState: DeckState,
    userSettings: UserSettings
}): { deck: OfficialDeckListRow[], lb: OfficialDeckListRow[] } {
    const addRow = (variant: CardVariant, list: OfficialDeckListRow[]) => {
        const quantity = props.deckState.editableFields.unsaved.totalCardsBySerial[variant.serial];

        let cardSerialWithoutRarity = variant.serial;
        CARD_RARITIES.forEach((rarity) => {
            if (cardSerialWithoutRarity.endsWith(rarity)) {
                cardSerialWithoutRarity = cardSerialWithoutRarity.substring(0, cardSerialWithoutRarity.length - rarity.length);
            }
        });
        
        Array.from(Array(quantity).keys()).forEach(() => {
            const row: OfficialDeckListRow = {
                name: variant.card.name ?? "",
                number: cardSerialWithoutRarity,
                rarity: variant.card.rarity
            };
    
            list.push(row);
        });
    }

    const newMainDeckRows: OfficialDeckListRow[] = [];
    const newLimitBreakDeckRows: OfficialDeckListRow[] = [];

    const cards = Object.values(props.deckState.cards).filter(x => !x.card.isLB);
    const lbs = Object.values(props.deckState.limitBreak);

    const mainDeckGroups: CardVariant[][] = groupCards(cards, props.userSettings);
    const limitBreakGroups: CardVariant[][] = groupCards(lbs, props.userSettings);

    mainDeckGroups.forEach((group) => {
        group.forEach((card) => addRow(card, newMainDeckRows));
    });

    limitBreakGroups.forEach((group) => {
        group.forEach((card) => addRow(card, newLimitBreakDeckRows));
    });

    return {
        deck: newMainDeckRows,
        lb: newLimitBreakDeckRows
    }
}

function groupCards(cards: CardVariant[], userSettings: UserSettings): CardVariant[][] {
    const cardsCopy = JSON.parse(JSON.stringify(cards));
    const result: CardVariant[][] = [];

    switch (userSettings.printableDeckListGroupBy) {
        case "None":
            sortCards(cardsCopy, userSettings);
            result.push(cardsCopy);
            return result;
        case "Type":
            groupCardsByType(cardsCopy, result, userSettings);
            return result;
        default:
            groupCardsByType(cardsCopy, result, userSettings);
            return result;
    }
}

function groupCardsByType(cards: CardVariant[], result: CardVariant[][], userSettings: UserSettings) {
    const forwards = cards.filter(x => x.card.type === "Forward");
    const backups = cards.filter(x => x.card.type === "Backup");
    const monsters = cards.filter(x => x.card.type === "Monster");
    const summons = cards.filter(x => x.card.type === "Summon");

    sortCards(forwards, userSettings);
    result.push(forwards);

    sortCards(backups, userSettings);
    result.push(backups);

    sortCards(monsters, userSettings);
    result.push(monsters);

    sortCards(summons, userSettings);
    result.push(summons);
}

function sortCards(cards: CardVariant[], userSettings: UserSettings) {
    switch (userSettings.printableDeckListSortBy) {
        case "Cost (Asc)":
            cards.sort((a, b) => (a.card.cost ?? 0) - (b.card.cost ?? 0));
            break;
        case "Serial (Desc)":
            cards.sort((a, b) => (b.altOpus ?? b.opus ?? 0) - (a.altOpus ?? a.opus ?? 0) || (a.altCardNumber ?? a.cardNumber ?? 0) - (b.altCardNumber ?? b.cardNumber ?? 0));
            break;
        default:
            cards.sort((a, b) => (b.altOpus ?? b.opus ?? 0) - (a.altOpus ?? a.opus ?? 0) || (a.altCardNumber ?? a.cardNumber ?? 0) - (b.altCardNumber ?? b.cardNumber ?? 0));
            break;
    }
}